export default __webpack_public_path__ + "static/media/detail_big_5_1.ae0d737f.png";